import { primaryKey } from '@mswjs/data';

/**
 * MSW DATA MODEL DEFINITIONS
 *
 * For new mock data, this is the place to start, but also see seedConfig below.
 *
 * In the modelDefinitions object the key is the model name, the value is the model definition.
 *
 * Example:
 *
 * Consider a model definition with name: 'person'
 *
 * The model definition might be:
 *
 * {
 *     // generated primary key is a faker uuid but may be overridden by the model instance
 *     id: primaryKey(faker.datatype.uuid)
 *
 *     // email is a string and must be provided by the model instance as it is not marked nullable
 *     email: String,
 *
 *     // age is a number and must be provided by model instance as it is not marked nullable
 *     age: Number,
 *
 *      // generated name is Frederick but may be overridden by the model instance
 *     name: () => 'Frederick',
 *
 *     // generated last name is random but may be overridden by the model instance
 *     lastName: faker.name.lastName,
 *
 *     // generated username is randomly selected but may be overridden by the model instance
 *     username: () => faker.random.arrayElement('fred', 'freddie', 'frodo'),
 *
 *     // pets is an array and must be provided by the model instance, as it is not marked nullable
 *     pets: Array
 *
 *     // title is a nullable string, it doesn't need to be provided by the model instance as it is marked nullable
 *     title: nullable(String)
 * }
 *
 * Note that each value in the model definition object is a function.
 *
 * Values MUST be functions, not primitives
 *
 * For further documentation please see the mswjs data doc, note especially the primaryKey and nullable
 * utility functions.
 *
 * https://github.com/mswjs/data
 *
 */
export const modelDefinitions = {
    userInfo: {
        sub: primaryKey(String),
        firstName: String,
        lastName: String,
        name: String,
        email: String,
        phoneNumber: String,
        isPhoneVerified: Boolean,
        picture: String,
        locale: String,
        accountResetDate: String
    }
};
